import AventurierZik from "../assets/music/aventurier.mp3";
import museZik from "../assets/music/muse.mp3";
import wewill from "../assets/music/wewill.mp3";
import smooth from "../assets/music/smooth.mp3";
import Bad from "../assets/images/Bad.png";
import aventurier from "../assets/images/aventurier.jpeg";
import Queen from "../assets/images/queen.jpeg";
import Muse from "../assets/images/muse.jpeg";

const titles = [
  {
    name: "Queen",
    album: "News of the World",
    title: "We Will Rock You",
    year: "1977",
    genre: "Rock",
    image: Queen,
    color: "#19CFFC",
    src: wewill,
    vibrate: [
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
      [150, 200, 150, 200, 150, 650],
    ],
    blanc:
      "----------------------------------------------------------------------------------------------",
    lyrics:
      "Buddy, you're a boy, make a big noise Playing in the street, gonna be a big man someday You got mud on your face, you big disgrace Kicking your can all over the place, singin' We will, we will rock you We will, we will rock you Buddy, you're a young man, hard man Shouting in the street, gonna take on the world someday You got blood on your face, you big disgrace  Waving your banner all over the place We will, we will rock you, sing it! We will, we will rock you, yeah Buddy, you're an old man, poor man Pleading with your eyes, gonna get you some peace someday You got mud on your face, big disgrace Somebody better put you back into your place, do it!  We will, we will rock you, yeah, yeah, come on We will, we will rock you, alright, louder! We will, we will rock you, one more time We will, we will rock you Yeah",
  },
  {
    name: "Michael Jackson",
    album: "Bad",
    title: "Smooth Criminal",
    year: "1988",
    genre: "Pop",
    image: Bad,
    color: "#19CFFC",
    src: smooth,
    vibrate: [
      [0, 300, 100, 50, 100, 50, 100, 50, 100, 50],
      [100, 50, 100, 50, 150, 150, 150, 450, 100, 50],
      [100, 50, 150, 150, 150, 450, 100, 50, 100, 50],
      [150, 150, 150, 450, 150, 150, 0, 300, 100, 50],
      [100, 50, 100, 50, 100, 50, 100, 50, 100, 50],
      [150, 150, 150, 450, 100, 50, 100, 50, 150, 150],
      [150, 450, 100, 50, 100, 50, 150, 150, 150, 450],
      [150, 150, 0, 300, 100, 50, 100, 50, 100, 50],
      [100, 50, 100, 50, 100, 50, 150, 150, 150, 450],
      [100, 50, 100, 50, 150, 150, 150, 450, 100, 50],
      [100, 50, 150, 150, 150, 450, 150, 150, 0, 300],
      [100, 50, 100, 50, 100, 50, 100, 50, 100, 50],
      [100, 50, 150, 150, 150, 450, 100, 50, 100, 50],
      [150, 150, 150, 450, 100, 50, 100, 50, 150, 150],
      [150, 450, 150, 150, 0, 0, 0, 0, 0, 0],
    ],
    blanc:
      "-----------------------------------------------------------------------------------------------------------------------------------------------------------------",
    speed: 110,
    lyrics:
      "As he came into the window Was the sound of a crescendo He came into her apartment He left the bloodstains on the carpet She ran underneath the table He could see she was unable So she ran into the bedroom She was struck down, it was her doom Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? Will you tell us that you're okay? There's a sound at the window Then he struck you, a crescendo Annie He came into your apartment He left the bloodstains on the carpet And then you ran into the bedroom You were struck down It was your doom Annie, are you okay?  So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? You've been hit by- You've been hit by- A smooth criminal So they came in to the outway It was Sunday, what a black day Mouth-to-mouth resuscitation Sounding heartbeats, intimidation Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay? So, Annie, are you okay? Are you okay, Annie? Annie, are you okay?Will you tell us that you're okay? There's a sound at the window That he struck you a crescendo Annie He came into your apartment He left the bloodstains on the carpet Then you ran into the bedroom You were struck down It was your doom Annie, are you okay? So, Annie, are you okay?  Are you okay, Annie? You've been hit by- You've been struck by- A smooth criminal Okay, I want everybody to clear the area right now Annie, are you okay? I don't know Will you tell us, that you're okay? I don't know There's a sound at the window I don't know Then he struck you, a crescendo Annie I don't know He came into your apartment I don't know Left bloodstains on the carpet I don't know why, baby And then you ran into the bedroom help me You were struck down It was your doom, Annie dag gone it Annie, are you okay? Dag gone it-baby Will you tell us that you're okay? Dag gone it-baby There's a sound at the window dag gone it-baby Then he struck you, a crescendo Annie He came into your apartment dag gone it Left bloodstains on the carpet hoo, hoo, hoo And then you ran into the bedroom You were struck down dag gone it It was your doom Annie",
  },
  {
    name: "Indochine",
    album: "L'aventurier",
    title: "L'aventurier",
    year: "1982",
    genre: "Pop",
    image: aventurier,
    color: "#FFE694",
    src: AventurierZik,
    vibrate: [
      [
        100, 250, 100, 90, 150, 80, 100, 200, 100, 150, 120, 80, 150, 250, 400,
        600,
      ],
      [
        100, 250, 100, 90, 150, 80, 100, 200, 100, 150, 150, 80, 150, 70, 150,
        70, 150, 700,
      ],
      [
        100, 250, 100, 90, 150, 80, 100, 200, 100, 150, 120, 80, 150, 250, 400,
        600,
      ],
      [
        100, 250, 100, 90, 150, 80, 100, 200, 100, 150, 150, 80, 150, 70, 150,
        70, 150, 700,
      ],
      [
        100, 250, 100, 90, 150, 80, 100, 200, 100, 150, 120, 80, 150, 250, 400,
        600,
      ],
      [
        100, 250, 100, 90, 150, 80, 100, 200, 100, 150, 150, 80, 150, 70, 150,
        70, 150, 700,
      ],
    ],
    blanc:
      "---------------------------------------------------------------------------------------------------------------------",
    lyrics:
      "Égaré dans la vallée infernale Le héros s'appelle Bob Morane À la recherche de l'Ombre Jaune Le bandit s'appelle mister Kali Jones Avec l'ami Bill Ballantine Sauvé de justesse des crocodiles Stop au trafic des Caraïbes Escale dans l'opération Nadawieb Le cœur tendre dans le lit de Miss Clark Prisonnière du Sultan de Jarawak En pleine terreur à Manicouagan Isolé dans la jungle birmane Emprisonnant les flibustiers L'ennemi y est démasqué On a volé le collier de Civa Le Maharadjah en répondra Et soudain surgit face au vent Le vrai héros de tous les temps Bob Morane contre tout chacal L'aventurier contre tout guerrier Bob Morane contre tout chacal L'aventurier contre tout guerrier Dérivant à bord du Sampang L'aventure au parfum d'Ylalang Son surnom, Samouraï du Soleil En démantelant le gang de l'Archipel L'otage des guerriers du Doc Xhatan Il s'en sortira toujours à temps Tel L'aventurier solitaire Bob Morane est le roi de la terre Et soudain surgit face au vent Le vrai héros de tous les temps Bob Morane contre tous chacal L'aventurier contre tout guerrier Bob Morane contre tout chacal L'aventurier contre tout guerrier",
  },
  {
    name: "Muse",
    album: "The 2nd Law",
    title: "Madness",
    year: "2012",
    genre: "Pop",
    image: Muse,
    color: "#098DFE",
    src: museZik,
    vibrate: [
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 320, 160, 320, 160],
      [320, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 320, 160, 320],
      [160, 320, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 320, 160],
      [320, 160, 320, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 320],
      [160, 320, 160, 320, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [320, 160, 320, 160, 320, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 320, 160, 320, 160, 320, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 320, 160, 320, 160, 320, 80, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 320, 160, 320, 160, 320, 80, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 320, 160, 320, 160, 320, 80],
      [80, 80, 80, 80, 80, 80, 80, 80, 80, 80],
      [80, 80, 80, 80, 80, 320, 160, 320, 160, 320],
    ],
    blanc:
      "---------------------------------------------------------------------------------------------------------------------",
    speed: 80,
    lyrics:
      "I, I can't get these memories out of my mind And some kind of madness has started to evolve I, I tried so hard to let you go But some kind of madness is swallowing me whole, yeah I have finally seen the light And I have finally realized What you mean Oh oh oh And now, I need to know is this real love Or is it just madness keeping us afloat? And when I look back at all the crazy fights we had Like some kind of madness Was taking control Yeah And now I have finally seen the light And I have finally realized What you need Mm And now I have finally seen the end (Finally seen the end) And I'm not expecting you to care (Expecting you to care) But I have finally seen the light (Finally seen the light) I have finally realized (Realized) I need to love I need to love Come to me, Trust in your dream Come on and rescue me Yes I have known, I can be wrong Maybe I'm too headstrong Our love is Madness",
  },
];

export default titles;
